// Edad en años cumplidos. Se lee en UTC porque el DatesProvider de DateInputES guarda las fechas
// como medianoche UTC. Devuelve NaN si la fecha no es válida.
export const edad = (fechaNacimiento) => {
  const nacimiento = new Date(fechaNacimiento);
  if (Number.isNaN(nacimiento.getTime())) return NaN;
  const hoy = new Date();
  let años = hoy.getUTCFullYear() - nacimiento.getUTCFullYear();
  const meses = hoy.getUTCMonth() - nacimiento.getUTCMonth();
  if (meses < 0 || (meses === 0 && hoy.getUTCDate() < nacimiento.getUTCDate())) años--;
  return años;
};

export default edad;
